const isInteger = (value: unknown): value is number => {
  return typeof value === 'number' &&
    isFinite(value) &&
    Math.floor(value) === value;
};

export {
  isInteger
};
